import { useQuery } from '@tanstack/react-query';
import { ApiError } from '@/lib/api/client';
import { fetchCurrentUser } from '@/services/userService';
import { queryKeys } from '@/lib/query/queryClient';
import type { CurrentUser } from '@/types/api';

/**
 * A valid Google session is not the same as having access. This is where the app finds
 * out whether the signed-in person is an active employee.
 *
 * `no_employee_record` is polled: someone signing in on their first morning may be
 * added minutes later, and it should resolve without them reloading. `wrong_domain` is
 * never polled — that answer will not change.
 */
export function useCurrentUser() {
  return useQuery<CurrentUser, ApiError>({
    queryKey: queryKeys.me,
    queryFn: fetchCurrentUser,
    refetchInterval(query) {
      return query.state.error?.reason === 'no_employee_record' ? 15_000 : false;
    },
  });
}
